import * as React from 'react';
import { WrappedFieldMetaProps } from 'redux-form/lib/Field';
import { withSiteData } from 'react-static';
import { connect } from 'react-redux';

import styles from './Input.scss';
import { SiteProps } from '../../SiteProps';
import { RootState } from '../../RootState';
import { Language } from '../../containers/Localization/localizationDuck';

interface StateProps {
  language: Language;
}

interface OwnProps {
  label?: string;
  className?: string;
  meta?: WrappedFieldMetaProps;
}

interface InputGroupProps extends OwnProps, StateProps, SiteProps {}

const Select: React.SFC<InputGroupProps> = ({
  label,
  className,
  children,
  meta,
  inputErrors,
  language,
}) => (
  <div className={`${styles.container} ${className}`}>
    {label && <label className={styles.label}>{label}</label>}
    {children}
    {meta &&
      meta.touched &&
      meta.error && <span className={styles.error}>{inputErrors[language][meta.error]}</span>}
  </div>
);

const mapStateToProps = (state: RootState) => ({
  language: state.localization.language,
});

export default connect<StateProps, {}, OwnProps, RootState>(mapStateToProps, () => ({}))(
  withSiteData(Select),
);



// WEBPACK FOOTER //
// /www/client/src/components/Input/InputGroup.tsx